import { api, getAccessToken } from './client';

export type DocType =
  | 'mrn'
  | 'pr'
  | 'rfq'
  | 'po'
  | 'grn'
  | 'grn-scan-receipt'
  | 'grn-out'
  | 'packing-scan-receipt'
  | 'packing-box-labels'
  | 'packing-box-label'
  | 'sales-invoice'
  | 'gate-pass'
  | 'quotation'
  | 'sales-order'
  | 'do-sales-order'
  | 'sales-order-review'
  | 'dept-transfer'
  | 'online-receipt';

/**
 * Backend HTML is auth-protected, so we fetch it via axios (which injects the
 * Bearer token) and return the raw HTML string. The caller is responsible for
 * rendering inside an iframe via srcdoc.
 */
export async function fetchDocHtml(type: DocType, id: number): Promise<string> {
  const r = await api.get<string>(`/docs/${type}/${id}`, { responseType: 'text' });
  return r.data;
}

/** Returns a presigned-ish URL useful for "open in new tab". Uses query-param token. */
export function docUrl(type: DocType, id: number): string {
  const base = (api.defaults.baseURL ?? '/api').replace(/\/$/, '');
  const token = getAccessToken();
  const t = token ? `?_t=${encodeURIComponent(token)}` : '';
  return `${base}/docs/${type}/${id}${t}`;
}
